import LoginLink from "@core/layouts/header/components/common/LoginLink";
import LogoutLink from "@core/layouts/header/components/common/LogoutLink";
import NcfzLogoutLink from "@core/layouts/header/components/common/NcfzLogoutLink";
import JoinLink from "@core/layouts/header/components/common/JoinLink";
import { shallow } from "zustand/shallow";
import { useAuthStore } from "@core/stores/authStore";
import { useAccountStore } from "@core/stores/accountStore";
import { cn } from "@core/utils/domUtil";

function LinkWrapper({ children }: { children: React.ReactNode }) {
  return (
    <span
      className={cn(
        "relative pl-[15px] first:before:hidden! last:before:absolute last:before:top-[50%] last:before:left-0 last:before:h-[12px] last:before:w-[1px] last:before:translate-y-[-50%] last:before:bg-gray-200",
      )}
    >
      {children}
    </span>
  );
}

export default function UtilPc() {
  const { isLogin, auth, isPlayncUser } = useAuthStore(
    (state) => ({
      isLogin: state.isLogin,
      auth: state.auth,
      isPlayncUser: state.isPlayncUser(),
    }),
    shallow,
  );
  const account = useAccountStore((state) => state.account);

  return (
    <div className="flex items-center gap-[12px]">
      {(auth === "PLAYNC_USER_0" || auth === "PLAYNC_USER_1") && account?.ncfzPlayncUserInfo?.personName && <LinkWrapper>{account?.ncfzPlayncUserInfo?.personName} 사장님</LinkWrapper>}
      {isLogin ? (
        <LinkWrapper>{!isPlayncUser ? <NcfzLogoutLink variant="text" size="large" /> : <LogoutLink variant="text" size="large" />}</LinkWrapper>
      ) : (
        <>
          <LinkWrapper>
            <LoginLink variant="text" size="large" />
          </LinkWrapper>
          <LinkWrapper>
            <JoinLink variant="text" size="large" />
          </LinkWrapper>
        </>
      )}
    </div>
  );
}
